// extracted by mini-css-extract-plugin
export default {"container":"prayerCountdown_container__B8wgq"};